/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon error codes which are supported in this app
 */
export enum FalconErrorCode {
  ERR_SESSION = "ERR_SESSION"
}
